
import { useState, useRef, useEffect, } from 'react'
import { useNavigate } from 'react-router-dom';
import DashboardShell from './components/DashboardShell'
import PersonalInformationSection from './PersonalInformationSection';
import EmploymentIncomeSection from './EmploymentIncomeSection';
import VehiclesSection from './VehiclesSection';
import RealEstateSection from './RealEstateSection';
import UnsecuredDebtSection from './UnsecuredDebtSection';
import RecommendationModal from '../components/RecommendationModal';
import ExpenseSection from './ExpenseSection';
import { computeBankruptcyConsultationResult } from '../consultation';
import { normalizeAttorneyFeeSettings } from '../utils/attorneyFeeSettings';
const API_URL = process.env.REACT_APP_API_URL;
const BACKEND_API_URL = process.env.REACT_APP_BACKEND_URL;
const initialCombinedState = {
  firstName: "", middleName: "", lastName: "", dob: "",
  chapter:"",
  bankruptcyFiled: "", bankruptcyChapter: "", bankruptcyCaseNumber: "", bankruptcyYearsAgo: "",
  maritalStatus: "", yearsMarried: "", spouseFiling: "",
  spouseFirstName: "", spouseMiddleName: "", spouseLastName: "",
  spouseDOB: "", spouseBankruptcyFiled: "", spouseBankruptcyChapter: "", spouseBankruptcyCaseNumber: "", spouseBankruptcyYearsAgo: "",
  statusDuration: "", dependents: "", dependentDetails: [], street: "", city: "", state: "", zip: "", county:"",
  phone: "", email: "", spousePhone: "", spouseEmail: "",
  employmentStatus: "", workPlace: "", jobTitle: "", jobDuration: "", startDate: "", hasPaymentAdvices: "yes",
  payType: "", hourlyRate: "", hoursWorked: "", yearlySalary: "", netProfit: "",
  deductions: [], secondJob: "", secondWorkPlace: "", secondJobTitle: "", secondJobDuration: "", secondStartDate: "", secondHasPaymentAdvices: "yes",
  secondPayType: "", secondHourlyRate: "", secondHoursWorked: "", secondYearlySalary: "", secondNetProfit: "",
  priorEmployment: "", priorWorkPlace: "", priorJobTitle: "", priorJobDuration: "", priorStartDate: "", priorLeavingDate: "", priorHasPaymentAdvices: "yes",
  priorPayType: "", priorHourlyRate: "", priorHoursWorked: "", priorYearlySalary: "", priorNetProfit: "",
  fixedIncomeSources: [], fixedIncomeDetails: {}, hasFixedIncome: "",
  spouseEmploymentStatus: "", spouseWorkPlace: "", spouseJobTitle: "", spouseJobDuration: "", spouseStartDate: "", spouseHasPaymentAdvices: "yes",
  spousePayType: "", spouseHourlyRate: "", spouseHoursWorked: "", spouseYearlySalary: "", spouseNetProfit: "",
  spouseDeductions: [], spouseSecondJob: "", spouseSecondWorkPlace: "", spouseSecondJobTitle: "", spouseSecondJobDuration: "", spouseSecondStartDate: "", spouseSecondHasPaymentAdvices: "yes",
  spouseSecondPayType: "", spouseSecondHourlyRate: "", spouseSecondHoursWorked: "", spouseSecondYearlySalary: "", spouseSecondNetProfit: "",
  spouseFixedIncomeSources: [], spouseFixedIncomeDetails: {}, spouseHasFixedIncome: "",
  spousePriorEmployment: "", spousePriorWorkPlace: "", spousePriorJobTitle: "", spousePriorJobDuration: "",
  spousePriorStartDate: "", spousePriorLeavingDate: "", spousePriorHasPaymentAdvices: "yes", spousePriorPayType: "", spousePriorHourlyRate: "",
  spousePriorHoursWorked: "", spousePriorYearlySalary: "", spousePriorNetProfit: "",
  hasVehicle: "", vehicles: [], spouseHasVehicle: "", spouseVehicles: [],
  ownsHome: "", homeOwnershipType: "", homePropertyType: "",homeOwnershipDetail: "", homeValue:"", hasMortgage: "", mortgageCreditor: "",
  mortgageBalance: "", mortgageMonthlyPayment: "", mortgagePaymentStatus: "", mortgageMonthsBehind: "",
  hasSecondMortgage: "", secondMortgageCreditor: "", secondMortgageBalance: "", secondMortgageMonthlyPayment: "",
  secondMortgagePaymentStatus: "", secondMortgageMonthsBehind: "",
  hasOtherRealEstate: "", otherRealEstateProperties: [], spouseHasOtherRealEstate: "", spouseOtherRealEstateProperties: [],
  creditCardDebt: "", creditCardDebtDetails: [], personalLoanDebt: "", personalLoanDebtDetails: [],
  medicalDebt: "", medicalDebtDetails: [], studentLoanDebt: "", studentLoanDebtDetails: [],
  backTaxDebt: "", backTaxDebtDetails: [], otherDebt: "", otherDebtDetails: [],
  spouseCreditCardDebt: "", spouseCreditCardDebtDetails: [], spousePersonalLoanDebt: "", spousePersonalLoanDebtDetails: [],
  spouseMedicalDebt: "", spouseMedicalDebtDetails: [], spouseStudentLoanDebt: "", spouseStudentLoanDebtDetails: [],
  spouseBackTaxDebt: "", spouseBackTaxDebtDetails: [], spouseOtherDebt: "", spouseOtherDebtDetails: [],
  paysRent: "", rentAmount: "", vehicleInsurance: "", childSupport: "", childSupportAmount: "",
  childSupportDeducted: "", childSupportArrearage: "", childSupportArrearageAmount: "", alimony: "", alimonyAmount: "",
  spouseChildSupport: "", spouseChildSupportAmount: "", spouseChildSupportDeducted: "",
  spouseChildSupportArrearage: "", spouseChildSupportArrearageAmount: "", spouseAlimony: "", spouseAlimonyAmount: "",
  override_chapter: "",
  override_prefiling_fee: "",
  override_chapter_13_payment_36: "",
  override_chapter_13_payment_60: "",
};

export default function CreateCasePage() {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showRec, setShowRec] = useState(false);
  const [recResult, setRecResult] = useState(null);
  const [errorMessages, setErrorMessages] = useState([]);
  const errorBoxRef = useRef(null);
  const [formData, setFormData] = useState(initialCombinedState);
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState("");
  const [openSection, setOpenSection] = useState("personal");
  const [invalidFields, setInvalidFields] = useState([]);
  const [firmFeeSettings, setFirmFeeSettings] = useState(null);
  const [attorneyFeeSchedules, setAttorneyFeeSchedules] = useState([]);
  const [selectedFeeSchedule, setSelectedFeeSchedule] = useState('firm');
  const [feeSettingsError, setFeeSettingsError] = useState('');

  useEffect(() => {
    let mounted = true;

    const loadFeeSettings = async () => {
      const token = localStorage.getItem('accessToken');
      try {
        const response = await fetch(`${API_URL}/firm/account/`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        if (!response.ok) throw new Error(`Unable to load fee settings (${response.status})`);
        const data = await response.json();
        if (!mounted) return;
        setFirmFeeSettings(data?.firm || null);
        setAttorneyFeeSchedules(Array.isArray(data?.attorneys) ? data.attorneys : []);
        setFeeSettingsError('');
      } catch (error) {
        if (!mounted) return;
        setFeeSettingsError(error.message || 'Unable to load fee settings.');
      }
    };

    loadFeeSettings();
    return () => {
      mounted = false;
    };
  }, []);

  const selectedAttorney = selectedFeeSchedule.startsWith('attorney:')
    ? attorneyFeeSchedules.find(
        (attorney) => String(attorney.id) === selectedFeeSchedule.slice('attorney:'.length)
      )
    : null;
  const activeFeeSettings = normalizeAttorneyFeeSettings(selectedAttorney || firmFeeSettings || {});
  async function emailIsTaken(email) {
    const res = await fetch(`${API_URL}/debtor-email-exists/?email=${encodeURIComponent(email)}`);
    if (!res.ok) throw new Error('Network error');
    const { exists } = await res.json();
    return exists;
  }
  const smoothScrollToTop = () => {
    const totalScroll = window.scrollY;
    const scrollStep = Math.PI / (500 / 15); // ~500ms total, updates every 15ms
    let count = 0;
    const cosParameter = totalScroll / 2;
  
    const scrollInterval = setInterval(() => {
      if (window.scrollY !== 0) {
        const scrollMargin = cosParameter - cosParameter * Math.cos(count * scrollStep);
        window.scrollTo(0, totalScroll - scrollMargin);
        count++;
      } else {
        clearInterval(scrollInterval);
      }
    }, 15);
  };
  useEffect(() => {
    if (errorMessages.length > 0 && errorBoxRef.current) {
      errorBoxRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
  
      const timer = setTimeout(() => {
        setErrorMessages([]);
      }, 4000); // 5 seconds
  
      return () => clearTimeout(timer); // clean up if errorMessages changes again
    }
  }, [errorMessages]);
  const handleSectionToggle = (sectionName) => {
    if (openSection === sectionName) {
      setOpenSection(null); // collapse if same section is clicked
    } else {
      setOpenSection(sectionName);
      setTimeout(smoothScrollToTop, 100); // slight delay to allow UI updates before scroll
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
  
    // Handle nested dependent fields like dependentDetails[0].age
    if (name.startsWith("dependentDetails[")) {
      const match = name.match(/dependentDetails\[(\d+)\]\.(\w+)/);
      if (match) {
        const [_, index, field] = match;
        setFormData(prev => {
          const updatedDependents = [...prev.dependentDetails];
          updatedDependents[parseInt(index)][field] = value;
          return { ...prev, dependentDetails: updatedDependents };
        });
        return;
      }
    }
  
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  const sanitizeFormData = (data) => {
    const cleaned = { ...data };
  
    // Marital Status Logic
    if (cleaned.maritalStatus !== "married") {
      cleaned.yearsMarried = "";
      cleaned.spouseFiling = "";
      cleaned.spouseFirstName = "";
      cleaned.spouseLastName = "";
      cleaned.spouseEmail = "";
      cleaned.spousePhone = "";
      cleaned.spousePriorBankruptcy = "";
      cleaned.spouseVehicles = [];
      cleaned.spouseOtherRealEstateProperties = [];
      cleaned.spouseCreditCardDebtDetails = [];
      cleaned.spousePersonalLoanDebtDetails = [];
      cleaned.spouseMedicalDebtDetails = [];
      cleaned.spouseStudentLoanDebtDetails = [];
      cleaned.spouseBackTaxDebtDetails = [];
      cleaned.spouseOtherDebtDetails = [];
      cleaned.spouseChildSupportAmount = "";
      cleaned.spouseAlimonyAmount = "";
      cleaned.spousePriorEmployer = "";
      cleaned.spousePriorJobTitle = "";
      cleaned.spousePriorStartDate = "";
      cleaned.spousePriorEndDate = "";
      cleaned.spousePriorPayType = "";
      cleaned.spousePriorPayRate = "";
      cleaned.spousePriorHoursWorked = "";
    }
  
    // Vehicle Logic
    if (cleaned.hasVehicle !== "yes") {
      cleaned.vehicles = [];
    }
    if (cleaned.spouseHasVehicle !== "yes") {
      cleaned.spouseVehicles = [];
    }
  
    // Home ownership
    if (cleaned.ownsHome !== "yes") {
      cleaned.homeValue = "";
      cleaned.homeOwnershipType = "";
      cleaned.hasMortgage = "";
      cleaned.mortgageCreditor = "";
      cleaned.mortgageBalance = "";
      cleaned.mortgageMonthlyPayment = "";
      cleaned.mortgagePaymentStatus = "";
      cleaned.mortgageMonthsBehind = "";
      cleaned.hasSecondMortgage = "";
      cleaned.secondMortgageCreditor = "";
      cleaned.secondMortgageBalance = "";
      cleaned.secondMortgageMonthlyPayment = "";
      cleaned.secondMortgagePaymentStatus = "";
      cleaned.secondMortgageMonthsBehind = "";
    }
  
    // Employment: Prior Employment Logic
    if (cleaned.priorEmployment !== "yes") {
      cleaned.priorEmployer = "";
      cleaned.priorJobTitle = "";
      cleaned.priorStartDate = "";
      cleaned.priorEndDate = "";
      cleaned.priorPayType = "";
      cleaned.priorPayRate = "";
      cleaned.priorHoursWorked = "";
    }
  
    if (cleaned.spousePriorEmployment !== "yes") {
      cleaned.spousePriorEmployer = "";
      cleaned.spousePriorJobTitle = "";
      cleaned.spousePriorStartDate = "";
      cleaned.spousePriorEndDate = "";
      cleaned.spousePriorPayType = "";
      cleaned.spousePriorPayRate = "";
      cleaned.spousePriorHoursWorked = "";
    }
  
    // Fixed Income: clean out if not selected
    if (cleaned.fixedIncome !== "yes") {
      cleaned.fixedIncomeSources = {};
    }
    if (cleaned.spouseFixedIncome !== "yes") {
      cleaned.spouseFixedIncomeSources = {};
    }
  
    // Rent
    if (cleaned.ownsHome === "yes") {
      cleaned.paysRent = "";
      cleaned.rentAmount = "";
    }
  
    // Vehicle Insurance
    if (cleaned.hasVehicle !== "yes" && cleaned.spouseHasVehicle !== "yes") {
      cleaned.vehicleInsurance = "";
    }
  
    // Child support follow-ups
    if (!cleaned.childSupportAmount || Number(cleaned.childSupportAmount) <= 0) {
      cleaned.childSupportDeducted = "";
      cleaned.childSupportArrearage = "";
      cleaned.childSupportArrearageAmount = "";
    }
  
    if (!cleaned.spouseChildSupportAmount || Number(cleaned.spouseChildSupportAmount) <= 0) {
      cleaned.spouseChildSupportDeducted = "";
      cleaned.spouseChildSupportArrearage = "";
      cleaned.spouseChildSupportArrearageAmount = "";
    }

    // Overrides (optional)
    if (!cleaned.override_chapter) cleaned.override_chapter = "";
    if (
      cleaned.override_prefiling_fee === null ||
      cleaned.override_prefiling_fee === undefined ||
      cleaned.override_prefiling_fee === ""
    ) {
      cleaned.override_prefiling_fee = "";
    }
    if (
      cleaned.override_chapter_13_payment_36 === null ||
      cleaned.override_chapter_13_payment_36 === undefined
    ) {
      cleaned.override_chapter_13_payment_36 = "";
    }
    if (
      cleaned.override_chapter_13_payment_60 === null ||
      cleaned.override_chapter_13_payment_60 === undefined
    ) {
      cleaned.override_chapter_13_payment_60 = "";
    }

    return cleaned;
  };
  async function addressToCensusData({ street, city, state, zip }) {
    const res = await fetch(`${BACKEND_API_URL}/api/geocode-fips`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ street, city, state, zip })
    });
    const data = await res.json();
    //console.log(data)
    if (!res.ok) {
      throw new Error(data.error || `Lookup failed (${res.status})`);
    }
    return data;
  }
  const validateAddressFields = async (addressObj) => {
    
    try {
      //console.log(addressObj)
      const response = await fetch(`${BACKEND_API_URL}/validate-address-intake`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(addressObj)
      });
      if (!response.ok) {
        throw new Error(await response.text());
      }
      const validatedAddress = await response.json();
  
      return validatedAddress;
    } catch (error) {
      console.error('Address validation error:', error);
      alert('Address validation failed: ' + error.message);
      return false;
    }
  };
  const validateRequiredFields = async (formData) => {
    const errors = [];
    const invalid = [];
  
    if (!formData.firstName?.trim()) {
      errors.push('First name is required.');
      invalid.push('firstName');
    }
    if (!formData.middleName?.trim()) {
      errors.push('Middle name is required.');
      invalid.push('middleName');
    }
    if (!formData.lastName?.trim()) {
      errors.push('Last name is required.');
      invalid.push('lastName');
    }
    if (!formData.email?.trim()) {
      errors.push('Email for debtor 1 is required.');
      invalid.push('email');
    } else {
      // only if they gave you an email, check uniqueness
      try {
        const taken = await emailIsTaken(formData.email);
        if (taken) {
          errors.push('That email is already associated with another case. Enter a different email.');
          invalid.push('email');
        }
      } catch (err) {
        errors.push('Could not verify email uniqueness. Try again.');
        invalid.push('email');
      }
    }
    if (!formData.dob?.trim()) {
      errors.push('Date of birth is required.');
      invalid.push('dob');
    }
    if (!formData.maritalStatus?.trim()) {
      errors.push('Marital status is required.');
      invalid.push('maritalStatus');
    }
    if (formData.maritalStatus === 'Married') {
      if (formData.spouseFiling === undefined || formData.spouseFiling === null) {
        errors.push('Please specify whether the spouse is filing.');
        invalid.push('spouseFiling');
      }
      if (formData.spouseFiling === 'yes') {
        if (!formData.spouseFirstName?.trim()) {
          errors.push('Spouse first name is required.');
          invalid.push('spouseFirstName');
        }
        if (!formData.spouseMiddleName?.trim()) {
          errors.push('Spouse middle name is required.');
          invalid.push('spouseMiddleName');
        }
        if (!formData.spouseLastName?.trim()) {
          errors.push('Spouse last name is required.');
          invalid.push('spouseLastName');
        }
        if (!formData.spouseDob?.trim()) {
          errors.push('Spouse date of birth is required.');
          invalid.push('spouseDob');
        }
        if (!formData.spouseEmail?.trim()) {
          errors.push('Spouse Email is required.');
          invalid.push('spouseEmail');
        }
        // Ensure spouse email is not the same as primary email
        if (formData.spouseEmail === formData.email) {
          errors.push('Spouse email must be different from primary email.');
          invalid.push('spouseEmail');
        }
        }
    }
  
    return {
      valid: errors.length === 0,
      errors,
      invalidFields: invalid
    };
  };
  const handleSubmit = async (e) => {
    e.preventDefault();  // make sure this is first
    const addressObj = {
      address1: formData.street,
      city:      formData.city,
      state:     formData.state,
      zip:       formData.zip
    };
    const verified = await validateAddressFields(addressObj);

    // If USPS returned a match, apply the standardized address
    if (verified.matches && verified.matches.length > 0 && verified.address) {
      const addr = verified.address;
      formData.street = addr.streetAddressAbbreviation;
      formData.street2 = addr.secondaryAddress || "";
      formData.city   = addr.city;
      formData.state  = addr.state;
      formData.zip    = addr.ZIPCode;
      // county is no longer provided by this API
      delete formData.county;
    }
    try {
      const censusData = await addressToCensusData({
        street: formData.street,
        city:   formData.city,
        state:  formData.state,
        zip:    formData.zip
      });
  
      // censusData.geocode    → full geocoder JSON
      // censusData.match      → the first match object
      // censusData.tracts     → full TigerWeb response
  
      // Example: grab the tract GEOID
      formData.censusTract = censusData.tracts.features[0].attributes;
      console.log(formData.censusTract)
      // You can also stash the rest:
      formData.censusGeocode = censusData.geocode;
      console.log(formData.censusGeocode)
      formData.censusMatch   = censusData.match;
      console.log(formData.censusMatch)
    } catch (err) {
      console.error("Census lookup failed:", err);
      // decide: block the user or just warn and continue
    }
    console.log("Submitting form data:", formData);
    console.log("Form Data Submitted:\n", JSON.stringify(formData, null, 2));
    formData.attorney_fee_settings = activeFeeSettings;
    formData.fee_schedule_attorney_id = selectedAttorney?.id || null;
    formData.fee_schedule_label = selectedAttorney
      ? `${selectedAttorney.first_name} ${selectedAttorney.last_name}`.trim()
      : 'Firm default';

    const result = await computeBankruptcyConsultationResult(formData);
    formData.consultationResult = result
    setRecResult(result);
    // await the async validator, and pull out valid/errors/invalidFields
    const { valid, errors, invalidFields } = await validateRequiredFields(formData);
  
    // if not valid, set your state and bail
    if (!valid) {
      setErrorMessages(errors);
      setInvalidFields(invalidFields);
      return;
    }
  
    // clear any previous errors
    setErrorMessages([]);
    setInvalidFields([]);
  
    setSubmitting(true);
    setIsSubmitting(true);
  
    try {
      const token = localStorage.getItem('accessToken');
      const res = await fetch(`${API_URL}/submit-case/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(formData)
      });
      const data = await res.json();
      if (res.ok) {
        setMessage("Case created successfully.");
        setFormData(initialCombinedState);
        setShowRec(true);
        //if (data.case_id) navigate(`/case/${data.case_id}`);
      } else {
        setMessage(data?.detail || "Something went wrong.");
      }
    } catch (err) {
      setMessage("Submission failed.");
    } finally {
      setSubmitting(false);
      setIsSubmitting(false);
      setShowRec(true);
    }
  };

  return (
    <div className="relative">
    <div className="min-h-screen">
    <DashboardShell>
          {showRec && (
              <RecommendationModal
                isOpen={showRec}
                onClose={() => setShowRec(false)}
                recommendationResult={recResult}
                answers={formData}
                computedValues={recResult.computedValues}
              />
            )}
      <div className="max-w-5xl mx-auto px-4 ">
        <h1 className="text-2xl font-bold mb-6 ">Create New Case</h1>
        {errorMessages.length > 0 && (
            <div ref={errorBoxRef} className="fixed top-5 left-1/2 transform -translate-x-1/2 z-50 max-w-lg w-full bg-red-50 border border-red-400 text-red-700 p-4 rounded shadow-lg animate-fade-out">
              <ul className="list-disc list-inside space-y-1">
                {errorMessages.map((error, index) => (
                  <li key={index}>{error}</li>
                ))}
              </ul>
            </div>
          )}
        <form onSubmit={handleSubmit} className="space-y-4">
          <fieldset className="border p-4 rounded bg-slate-50">
          
          <PersonalInformationSection
            data={formData}
            onChange={handleChange}
            onAddDependent={() =>
              setFormData(prev => ({
                ...prev,
                dependentDetails: [...prev.dependentDetails, { age: "", relation: "" }]
              }))
            }
            onRemoveDependent={(index) =>
              setFormData(prev => ({
                ...prev,
                dependentDetails: prev.dependentDetails.filter((_, i) => i !== index)
              }))
            }
            isOpen={openSection === "personal"}
            onOpen={() => handleSectionToggle("personal")}
          />
          <EmploymentIncomeSection
            data={formData}
            onChange={handleChange}
            onAddDependent={() =>
              setFormData(prev => ({
                ...prev,
                dependentDetails: [...prev.dependentDetails, { age: "", relation: "" }]
              }))
            }
            onRemoveDependent={(index) =>
              setFormData(prev => ({
                ...prev,
                dependentDetails: prev.dependentDetails.filter((_, i) => i !== index)
              }))
            }
            isOpen={openSection === "employment"}
            onOpen={() => handleSectionToggle("employment")}
          />
          <VehiclesSection
            data={formData}
            onAddVehicle={(field) =>
              setFormData(prev => ({
                ...prev,
                [field]: [
                  ...prev[field],
                  {
                    year: "", make: "", model: "", miles: "",
                    ownership: "", creditor: "", loanBalance: "", monthlyPayment: "",
                    currentOnPayments: "", monthsBehind: "", keep: ""
                  }
                ]
              }))
            }
            onRemoveVehicle={(field, index) =>
              setFormData(prev => ({
                ...prev,
                [field]: prev[field].filter((_, i) => i !== index)
              }))
            }
            onUpdateVehicle={(field, index, key, value) =>
              setFormData(prev => {
                const updated = [...prev[field]];
                updated[index][key] = value;
                return { ...prev, [field]: updated };
              })
            }
            isOpen={openSection === "vehicles"}
            onOpen={() => handleSectionToggle("vehicles")}
          />
          <RealEstateSection
            data={formData}
            onChange={handleChange}
            onAddProperty={(isSpouse = false) => {
              setFormData((prev) => {
                const key = isSpouse ? "spouseOtherRealEstateProperties" : "otherRealEstateProperties";
                return {
                  ...prev,
                  [key]: [
                    ...(prev[key] || []),
                    {
                      address: "",
                      ownership: "",
                      hasMortgage: "",
                      mortgageCreditor: "",
                      mortgageBalance: "",
                      mortgageMonthlyPayment: "",
                      mortgagePaymentStatus: "",
                      mortgageMonthsBehind: "",
                      hasSecondMortgage: "",
                      secondMortgageCreditor: "",
                      secondMortgageBalance: "",
                      secondMortgageMonthlyPayment: "",
                      secondMortgagePaymentStatus: "",
                      secondMortgageMonthsBehind: "",
                    },
                  ],
                };
              });
            }}
            onRemoveProperty={(index, isSpouse = false) =>
              setFormData((prev) => {
                const key = isSpouse ? "spouseOtherRealEstateProperties" : "otherRealEstateProperties";
                return {
                  ...prev,
                  [key]: prev[key].filter((_, i) => i !== index),
                };
              })
            }
            isOpen={openSection === "realEstate"}
            onOpen={() => handleSectionToggle("realEstate")}
          />
          <UnsecuredDebtSection
            data={formData}
            onChange={handleChange}
            isOpen={openSection === "debts"}
            onOpen={() => handleSectionToggle("debts")}
          />
          {formData.maritalStatus === "married" && formData.spouseFiling === "yes" && (
            <UnsecuredDebtSection
              data={formData}
              onChange={handleChange}
              isSpouse={true}
              isOpen={openSection === "spouseDebts"}
              onOpen={() => handleSectionToggle("spouseDebts")}
          />
          )}
          
          <ExpenseSection data={formData} onChange={handleChange}
          isOpen={openSection === "expenses"}
          onOpen={() => handleSectionToggle("expenses")} />
          <div className="bg-white rounded shadow mb-4">
            <button
              type="button"
              onClick={() => handleSectionToggle("override")}
              className="w-full flex items-center justify-between px-4 py-3"
            >
              <div className="flex items-center gap-2">
                <h2 className="text-lg font-semibold text-gray-900">Override Recommendation</h2>
                <span className="text-xs text-gray-500">(optional)</span>
              </div>
              <span className="text-gray-500">
                {openSection === "override" ? (
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z" clipRule="evenodd" />
                  </svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M14.77 12.79a.75.75 0 01-1.06-.02L10 9.06l-3.71 3.71a.75.75 0 11-1.06-1.06l4.24-4.24a.75.75 0 011.06 0l4.24 4.24c.29.29.3.76.02 1.08z" clipRule="evenodd" />
                  </svg>
                )}
              </span>
            </button>

            {openSection === "override" && (
              <div className="px-4 pb-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Attorney Fee Schedule</label>
                    <select
                      value={selectedFeeSchedule}
                      onChange={(event) => setSelectedFeeSchedule(event.target.value)}
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    >
                      <option value="firm">Firm default</option>
                      {attorneyFeeSchedules.map((attorney) => (
                        <option key={attorney.id} value={`attorney:${attorney.id}`}>
                          {attorney.first_name} {attorney.last_name}
                        </option>
                      ))}
                    </select>
                    <p className="mt-1 text-xs text-gray-500">
                      Ch. 7 base ${activeFeeSettings.base_chapter_7.toLocaleString()} · Ch. 13 unsecured ${activeFeeSettings.chapter_13_unsecured_fee.toLocaleString()} · Ch. 13 max ${activeFeeSettings.chapter_13_max_fee.toLocaleString()}
                    </p>
                    {feeSettingsError && (
                      <p className="mt-1 text-xs text-amber-700">{feeSettingsError} Calculator fallbacks will be used.</p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Override Chapter</label>
                    <select
                      name="override_chapter"
                      value={formData.override_chapter || ""}
                      onChange={handleChange}
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    >
                      <option value="">No override</option>
                      <option value="7">Chapter 7</option>
                      <option value="13">Chapter 13</option>
                    </select>
                    <p className="mt-1 text-xs text-gray-500">If set, this will override the consultation recommendation.</p>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Override Prefiling Attorney Fee</label>
                    <input
                      type="number"
                      name="override_prefiling_fee"
                      value={formData.override_prefiling_fee || ""}
                      onChange={handleChange}
                      placeholder="e.g. 1200"
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                    <p className="mt-1 text-xs text-gray-500">Leave blank to use the firm defaults / calculator.</p>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Override 36-Month Chapter 13 Payment</label>
                    <input
                      type="number"
                      min="0"
                      step="0.01"
                      name="override_chapter_13_payment_36"
                      value={formData.override_chapter_13_payment_36 || ""}
                      onChange={handleChange}
                      placeholder="Leave blank for auto-calculation"
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                    <p className="mt-1 text-xs text-gray-500">If entered, this becomes the displayed and saved 36-month monthly payment.</p>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Override 60-Month Chapter 13 Payment</label>
                    <input
                      type="number"
                      min="0"
                      step="0.01"
                      name="override_chapter_13_payment_60"
                      value={formData.override_chapter_13_payment_60 || ""}
                      onChange={handleChange}
                      placeholder="Leave blank for auto-calculation"
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                    <p className="mt-1 text-xs text-gray-500">If entered, this becomes the displayed and saved 60-month monthly payment.</p>
                  </div>
                </div>
              </div>
            )}
          </div>
          </fieldset>
          <button type="submit" className="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
            {submitting ? 'Submitting...' : 'Submit Case'}
          </button>
          {message && <div className="mt-4 text-center font-medium">{message}</div>}
        </form>
        </div>
        
    </DashboardShell></div>
    {isSubmitting && (
          <>
            <div className="absolute inset-0 bg-gray-400 opacity-50 pointer-events-none z-40"></div>
            <div className="absolute inset-0 flex items-center justify-center z-50">
              <svg
                className="animate-spin h-12 w-12 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8z"
                ></path>
              </svg>
            </div>
          </>
        )}
      </div>
  );
}
